<script>
import { GlAlert, GlLink, GlSprintf } from '@gitlab/ui';
import { CONTACT_SUPPORT_LINK } from '~/javascripts/constants';

/*
This component is deprecated. Please use the ~/javascripts/components/error_alert.vue
instead as it has support for multiple links and providing an error disctionary for
displaying user friendly messages.

For alerts that contain a single link.
*/
export default {
  name: 'DeprecatedAlertWithLink',
  components: {
    GlAlert,
    GlLink,
    GlSprintf,
  },
  props: {
    alertMessage: {
      type: String,
      required: false,
      default: '',
    },
    alertVariant: {
      type: String,
      required: false,
      default: 'danger',
    },
    alertLink: {
      type: String,
      required: false,
      default: CONTACT_SUPPORT_LINK,
    },
  },
};
</script>

<template>
  <gl-alert :dismissible="false" class="gl-my-5" :variant="alertVariant">
    <gl-sprintf :message="alertMessage">
      <template #link="{ content }">
        <gl-link class="!gl-no-underline" :href="alertLink" target="_blank">{{ content }}</gl-link>
      </template>
    </gl-sprintf>
  </gl-alert>
</template>
